// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_35RW3_H4vL0wVUc81qnipc"};